import { ErrorBase } from './error.base';

export class ErrorUnknown extends ErrorBase {

    constructor(name: string, message: string) {
        super(name, message);
    }

}
